/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerErsUsageReportDTO } from './customer-ers-usage-report-dto';
import { ErsUsageDTO } from './ers-usage-dto';


export interface BusinessPremisesUsageReportAllOfDTO { 
    usage?: CustomerErsUsageReportDTO;
    erses?: Array<ErsUsageDTO>;
}

export class ClsBusinessPremisesUsageReportAllOfDTO { 
    usage?: CustomerErsUsageReportDTO = undefined;
    erses?: Array<ErsUsageDTO> = undefined;
}

